
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$pagination.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$pagination.js';
export default __default__;
